import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useAuth0Context } from "@/contexts/Auth0Context";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export function ProtectedRoute({
  children,
  requireAdmin = false,
}: ProtectedRouteProps) {
  const { user: legacyUser, isLoading: legacyLoading } = useAuth();
  const {
    user: auth0User,
    isLoading: auth0Loading,
    isAuthenticated: auth0Authenticated,
  } = useAuth0Context();

  const isLoading = legacyLoading || auth0Loading;
  const isAuthenticated = auth0Authenticated || !!legacyUser;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <span className="text-lg text-muted-foreground">Loading...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // For Auth0 users, check roles differently (from token claims)
  if (requireAdmin) {
    const isAdmin = auth0User
      ? auth0User["https://api.snaplading.com/roles"]?.includes("admin") ||
        auth0User.roles?.includes("admin") ||
        auth0User.role === "Admin"
      : legacyUser?.role === "Admin";

    if (!isAdmin) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background">
          <span className="text-lg text-destructive">
            Access denied. Admin privileges required.
          </span>
        </div>
      );
    }
  }

  return <>{children}</>;
}
